export const onReady: Map<string, () => void> = new Map()

export function register(name: string, fn: () => void) {
	if (onReady.has(name)) {
        console.warn(`[register] "${name}" already registered`)
        return
    }
	
    onReady.set(name,fn)
}